<template>
  <div class="screen-wrap">
    <div class="con">
      <radio-select v-model="leaveType"
                    title="请假类型"
                    :selectList="typeList" />
      <radio-select v-model="approvalStatus"
                    title="审批结果"
                    :selectList="typeStatusList" />
      <div class="title">申请时间</div>
      <div class="choose-time">
        <div class="start"
             @click="isShowStartDate = true">
          <span>开始时间</span>
          <div class="van-hairline--surround f14">
            <em v-show="startDate === ''">请选择</em>
            <p class="top">{{startDate}}</p>
            <!-- <p class="bot">{{startHour}}</p> -->
          </div>
        </div>
        <div class="center">
          <van-icon name="arrow" />
        </div>
        <div class="end"
             @click="isShowEndDate = true">
          <span>结束时间</span>
          <div class="van-hairline--surround f14">
            <em v-show="endDate === ''">请选择</em>
            <p class="top">{{endDate}}</p>
            <!-- <p class="bot">{{endHour}}</p> -->
          </div>
        </div>
      </div>
      <div class="two-bottom-btn">
        <van-button round
                    @click="resetCondition"
                    type="info"
                    plain
                    style="width: 150px;">重置</van-button>
        <van-button round
                    type="info"
                    @click="confirmCondition"
                    style="width: 150px; margin-left: 30px;">完成</van-button>
      </div>
      <!-- 选择开始时间 -->
      <van-popup v-model="isShowStartDate"
                 position="bottom"
                 :style="{ height: '45%' }">
        <van-datetime-picker v-model="startCurrentDate"
                             @cancel="startCancel"
                             @confirm="startConfirm"
                             :formatter="formatter"
                             :max-date="maxDate"
                             type="date"></van-datetime-picker>
      </van-popup>
      <!-- 选择结束时间 -->
      <van-popup v-model="isShowEndDate"
                 position="bottom"
                 :style="{ height: '45%' }">
        <van-datetime-picker v-model="endCurrentDate"
                             @cancel="endCancel"
                             @confirm="endConfirm"
                             :formatter="formatter"
                             :max-date="maxDate"
                             type="date"></van-datetime-picker>
      </van-popup>
    </div>
  </div>
</template>
<script>
import { Notify } from "vant";
import RadioSelect from "./RadioSelect";

export default {
  name: "ScreenItems",
  props: {},
  components: {
    RadioSelect
  },
  data () {
    return {
      //请假类型
      leaveType: -1,
      typeList: [
        {
          name: "全部",
          id: -1
        }
      ],
      //审批状态
      approvalStatus: -1,
      typeStatusList: [
        {
          id: -1,
          name: "全部"
        },
        {
          id: 0,
          name: "待审批"
        },
        {
          id: 1,
          name: "审批中"
        },
        {
          id: 2,
          name: "已通过"
        },
        {
          id: 3,
          name: "已拒绝"
        },
        {
          id: 4,
          name: "已撤销"
        }
      ],

      //date搜索
      maxDate: new Date(), //new Date(2019, 11, 20),

      isShowStartDate: false,
      startCurrentDate: new Date(),
      startDate: "", //开始时间
      startHour: "",

      isShowEndDate: false,
      endDate: "", //结束时间
      endHour: "",
      endCurrentDate: new Date()
    };
  },
  created () {
    this.getType();
  },
  methods: {
    async getType () {
      let that = this;
      let res = await this.xyapi.get(
        this.$store.state.apiPath + "/api/StudentLeaveMb/GetTypeAll"
      );
      if (res.success) {
        res.data.length &&
          res.data.forEach(function (value) {
            that.typeList.push({
              name: value.LeaveTypeName,
              id: value.LeaveTypeID
            });
          });
      } else {
        Notify({ type: "danger", message: res.msg });
      }
    },

    //取消选择开始时间
    startCancel () {
      this.isShowStartDate = false;
    },
    //确认选择开始时间
    startConfirm (value) {
      this.startDate = value.pattern("yyyy.MM.dd");
      this.startHour = value.pattern("HH:mm");
      this.isShowStartDate = false;
    },
    //取消选择结束时间
    endCancel () {
      this.isShowEndDate = false;
    },
    //确认选择结束时间
    endConfirm (value) {
      this.endDate = value.pattern("yyyy.MM.dd");
      this.endHour = value.pattern("HH:mm");
      this.isShowEndDate = false;
    },
    //选项格式化
    formatter (type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      } else if (type === "day") {
        return `${value}日`;
      } else if (type === "hour") {
        return `${value}时`;
      } else if (type === "minute") {
        return `${value}分`;
      }
      return value;
    },

    resetCondition () {
      this.leaveType = -1; //重置失效了？？？？
      this.approvalStatus = -1; //重置失效了？？？？

      //重置时间范围
      this.startDate = "";
      this.startHour = "";
      this.endDate = "";
      this.endHour = "";
    },
    //确认筛选 发送事件
    confirmCondition () {
      this.$emit("submitFun", {
        leaveType: this.leaveType,
        approvalStatus: this.approvalStatus,
        startDate: this.startDate,
        endDate: this.endDate
      });
      //startDate: `${this.startDate} ${this.startHour}`,
      //endDate: `${this.endDate} ${this.endHour}`
    }
  }
};
</script>

<style lang="less" scoped>
.screen-wrap {
  position: fixed;
  width: 100%;
  height: calc(100% - 190px);
  left: 0;
  top: 190px;
  z-index: 9;
  background: rgba(0, 0, 0, 0.5); //弹框展示一半时的黑色遮罩
  .con {
    width: 100%;
    height: 100%;
    padding: 0 39px;
    background: #fff;
    border-top: 2px solid #dedede;
    overflow: overlay;
    .choose-time {
      display: flex;
      margin-top: 10px;
      margin-bottom: 150px;
      .start,
      .end {
        width: 40%;
        > span {
          display: block;
          color: #666;
          font-size: 26px;
          margin-bottom: 26px;
        }
        > div {
          height: 100px;
          background: #f5faff;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          p.top {
            color: #666;
          }
          p.bot {
            color: #111;
          }
          em {
            line-height: 75px;
          }
        }
      }
      .center {
        width: 20%;
        text-align: center;
        margin-top: 15%;
        color: #999;
      }
    }
    .title {
      font-size: 28px;
      line-height: 110px;
      color: #111;
      position: relative;
      .radio-con {
        display: flex;
        position: absolute;
        top: 38px;
        left: 148px;
      }
    }
  }
  .two-bottom-btn {
    height: 150px;
    line-height: 150px;
    background: #000;
    background: rgba(255, 255, 255, 1);
    //box-shadow:0px 2px 21px 0px rgba(186,186,186,0.44);
    position: absolute;
    left: 0;
    bottom: -1%;
    width: 100%;
    padding: 38px 70px;
    display: flex;
    align-items: center;
    .cancel {
      flex: 1;
    }
    .submit {
      flex: 1;
      margin-left: 70px;
    }
  }
}
</style>
